import { render, staticRenderFns } from "./Arrange.vue?vue&type=template&id=60147ad5&scoped=true&"
import script from "./Arrange.vue?vue&type=script&lang=js&"
export * from "./Arrange.vue?vue&type=script&lang=js&"
import style0 from "./Arrange.vue?vue&type=style&index=0&id=60147ad5&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60147ad5",
  null
  
)

export default component.exports